import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { ButtonCtaComponent } from '@components/button-cta/button-cta.component';
import { SHIPROCKET_FILL_ADDRESS_ACTION } from '../../app.constants';
import { CsIconModule } from '@components/icon';

@Component({
  selector: 'app-shiprocket-fill-address-bottomsheet',
  templateUrl: './shiprocket-fill-address-bottomsheet.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonCtaComponent, CsIconModule],
})
export class ShiprocketFillAddressBottomsheetComponent {
  private readonly bottomSheetRef = inject(MatBottomSheetRef<ShiprocketFillAddressBottomsheetComponent>);

  dismiss(): void {
    this.bottomSheetRef.dismiss();
  }

  onAddManually(): void {
    this.bottomSheetRef.dismiss({ action: SHIPROCKET_FILL_ADDRESS_ACTION.Manual });
  }

  onGetAddress(): void {
    this.bottomSheetRef.dismiss({ action: SHIPROCKET_FILL_ADDRESS_ACTION.Shiprocket });
  }
}
